export enum BulkActionType {
  Amortization = 'amortization',
  Hypothetical = 'hypothetical',
  JournalEntries = 'journalEntries',
  JournalEntriesMovement = 'journalEntriesMovement',
  Effectiveness = 'effectiveness',
}
